import {sleep} from '../utils.ts';

const {appSubUrl, sharedWorkerUri} = window.config;

export async function logoutFromWorker(): Promise<void> {
  // wait for a while because other requests (eg: logout) may be in the flight
  await sleep(5000);
  window.location.href = `${appSubUrl}/`;
}

export class UserEventsSharedWorker {
  sharedWorker: SharedWorker;

  // name is the debug name of the worker, also used as the SharedWorker dedup key.
  constructor(name?: string) {
    const worker = new SharedWorker(sharedWorkerUri, {name, type: 'module'});
    this.sharedWorker = worker;
    worker.addEventListener('error', (event) => {
      console.error('worker error', event);
    });
    worker.port.addEventListener('messageerror', () => {
      console.error('unable to deserialize message');
    });
    worker.port.postMessage({
      type: 'start',
      url: `${window.location.origin}${appSubUrl}/user/events`,
    });
    worker.port.addEventListener('error', (e) => {
      console.error('worker port error', e);
    });
    window.addEventListener('beforeunload', () => {
      worker.port.postMessage({type: 'close'});
      worker.port.close();
    });
  }

  addMessageEventListener(listener: (event: MessageEvent) => void) {
    this.sharedWorker.port.addEventListener('message', (event: MessageEvent) => {
      if (!event.data || !event.data.type) {
        console.error('unknown worker message event', event);
        return;
      }

      if (event.data.type === 'error') {
        console.error('worker port event error', event.data);
      } else if (event.data.type === 'logout') {
        if (event.data.data !== 'here') return;
        this.sharedWorker.port.postMessage({type: 'close'});
        this.sharedWorker.port.close();
        logoutFromWorker();
      } else if (event.data.type === 'close') {
        this.sharedWorker.port.postMessage({type: 'close'});
        this.sharedWorker.port.close();
      }
      listener(event);
    });
  }

  startPort() {
    this.sharedWorker.port.start();
  }
}
